enum NavigationSource {
  UserActivation = 'user-activation',
  ResetPassword = 'reset-password',
}

export default NavigationSource;
